import { render } from "./user-recharge.vue?vue&type=template&id=9ba2da2e"
import script from "./user-recharge.vue?vue&type=script&lang=js"
export * from "./user-recharge.vue?vue&type=script&lang=js"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__